import { z } from 'zod';
import {
  BaseElementSchema,
  PointSchema,
} from '@/components/canvas/document/schema/elementBase';

export const LineElementSchema = BaseElementSchema.extend({
  type: z.literal('line'),
  data: z.object({
    start: PointSchema.optional(),
    end: PointSchema.optional(),
  }),
});
